import standardTypes from "./standard.type";
import standardService from "./standard.service";

// Fetch standard codes with pagination
const getStandardCodeWithPagination = (queryString) => {
  return async (dispatch) => {
    dispatch({ type: standardTypes.GET_STANDARD_CODE_REQUEST });

    try {
      const data = await standardService.getStandardCodeWithPagination(queryString);
      dispatch({
        type: standardTypes.GET_STANDARD_CODE_SUCCESS,
        payload: data,
      });
    } catch (error) {
      dispatch({
        type: standardTypes.GET_STANDARD_CODE_FAILURE,
        error,
      });
    }
  };
};



export default {
  getStandardCodeWithPagination,
};
